import React from 'react';
import { Link } from '@sls-react/routing';
import { AnchorProps } from '@sls-react/components/Links/A';

type Props = AnchorProps & {
  page: 'invite';
};

const ReferralLink: React.FC<Props> = ({ children, page, ...props }) => (
  <Link href={`/${page}`} passHref>
    <a {...props}>{children}</a>
  </Link>
);

export default ReferralLink;
